import React, { useEffect, useState } from 'react';

interface Props {
  imgPath: string;
  className?: string;
  click?: () => void;
}

const Icon: React.FC<Props> = ({ imgPath, className, click }) => {
  const [image, setImage] = useState('');

  const handleClick = () => {
    if (click) click();
  };

  useEffect(() => {
    import('../../../assets' + imgPath).then(img => {
      setImage(img.default);
    });
  }, [imgPath]);

  return <> {image && <img src={image} alt="" className={className} onClick={handleClick} />} </>;
};

export default Icon;
